import {
  LeftCircleTwoTone,
  DeleteTwoTone,
  RightCircleTwoTone,
} from '@ant-design/icons'
import { Typography, Space, Input, Button } from 'antd'
import { FilenameTemplate } from '@cims-online/shared'
import CIMSFormItem from 'components/CIMSFormItem'
import { EditFilenameModalProps } from '../../types'
import { HelpMessage } from 'utils/constants'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import Tag from './components/Tag'

function EditTemplateItems<T>({
  context,
  type,
}: Pick<EditFilenameModalProps<T>, 'context' | 'type'>) {
  const { templateItems, setTemplateItems, valid, isDisabled } = context
  const { customFieldIdToProjectCustomField } = useProjectCustomFieldsContext()
  return (
    <CIMSFormItem
      label="Template"
      help={HelpMessage.Exports.Template(type)}
      description={
        valid ? undefined : (
          <Typography.Text type="danger">
            Invalid characters found
          </Typography.Text>
        )
      }
    >
      <Space wrap size="middle">
        {(templateItems ?? []).map((item, index) => {
          let formItem
          if (item.type === 'custom') {
            formItem = (
              <Input
                allowClear
                value={item.value}
                onChange={({ target: { value } }) =>
                  setTemplateItems((prev) => {
                    const items = Array.from(prev)
                    items[index] = { type: 'custom', value }
                    return items
                  })
                }
                autoFocus
                status={
                  FilenameTemplate.isIllegal(item.value) ? 'error' : undefined
                }
              />
            )
          } else if (item.type === 'templateItem') {
            const disabled = isDisabled(item.value)
            const { help, name } = FilenameTemplate.fromIdOrFail(item.value)
            formItem = (
              <Tag
                tooltip={
                  disabled
                    ? `${help}. This value should be set before generating any reports`
                    : help
                }
              >
                {name}
              </Tag>
            )
          } else if (item.type === 'customField') {
            const { name, description } =
              customFieldIdToProjectCustomField.get(item.value) ?? {}
            formItem = <Tag tooltip={description}>{name}</Tag>
          } else formItem = null
          return (
            <Space key={index} size={1}>
              {index !== 0 && (
                <Button
                  size="small"
                  icon={<LeftCircleTwoTone />}
                  onClick={() => {
                    const to = index - 1
                    setTemplateItems((prev) => {
                      const next = Array.from(prev)
                      ;[next[index], next[to]] = [next[to], next[index]]
                      return next
                    })
                  }}
                />
              )}
              {formItem}
              <Button
                icon={<DeleteTwoTone />}
                size="small"
                onClick={() =>
                  setTemplateItems((prev) => prev.filter((_, i) => i !== index))
                }
              />
              {index !== templateItems.length - 1 && (
                <Button
                  size="small"
                  icon={<RightCircleTwoTone />}
                  onClick={() => {
                    const to = index + 1
                    setTemplateItems((prev) => {
                      const next = Array.from(prev)
                      ;[next[index], next[to]] = [next[to], next[index]]
                      return next
                    })
                  }}
                />
              )}
            </Space>
          )
        })}
      </Space>
    </CIMSFormItem>
  )
}

export default EditTemplateItems
